<p mat-dialog-title>Zmiana agenta</p>
<mat-dialog-content>
	<mat-radio-group [(ngModel)]="searchType" ngDefaultControl class="d-flex flex-row gap-3">
		<mat-label>Wyszukaj po</mat-label>
		<mat-radio-button value="N">Nazwie</mat-radio-button>
		<mat-radio-button value="C">Mieście</mat-radio-button>
		<mat-radio-button value="M">MerlinX</mat-radio-button>
	</mat-radio-group>
	<mat-form-field appearance="outline" class="w-100 dialog__formField mt-3">
		<mat-label>Wyszukaj agenta</mat-label>
		<input matInput type="text" [formControl]="sellerSelect" [matAutocomplete]="auto" />
		<mat-autocomplete
			#auto="matAutocomplete"
			[displayWith]="displayFn.bind(this)"
			(optionSelected)="selectSeller($event)"
		>
			<mat-option [value]="seller.id" *ngFor="let seller of filteredSellers">{{ seller.name }}</mat-option>
		</mat-autocomplete>
		<mat-hint>Wpisz nazwe, miasto, numer MerlinX</mat-hint>
	</mat-form-field>
	<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
	<button mat-raised-button color="warn" class="agent__closeButton" (click)="closeDialog()">Anuluj</button>
	<button mat-raised-button color="primary" [disabled]="isSelectedSeller$ | async" (click)="submit()">Zmień</button>
</mat-dialog-actions>
